import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *运营列表
 * @param params
 * 
*/

export const operationList = params => Http.get(`${baseUrl}/sz/team/yy/my`, { params })

/**
 *上传视频到抖音
 * @param params
 * 
*/

export const uploadDy = params => Http.post(`${baseUrl}/sz/team/yy/${params.waId}/upload2douyin`, params )

/**
 *团队运营列表
 * @param params
 * 
*/

export const result = params => Http.get(`${baseUrl}/sz/team/yy`, { params })
